import PropTypes from 'prop-types';
import { usePrefs, useSitemap } from 'wsm-common-data';
import logger from 'ws-scripts/modules/logger';
import { EvModal, CustomMarkupModal, useFetchFragment } from 'wsm-common-modal';

const Modals = ({ activeFacetModal, options }) => {
	const sitemap = useSitemap();
	const { showClassificationLink } = usePrefs();

	const classificationModalHref = sitemap.get(showClassificationLink);

	const { data, isLoading, isError } = useFetchFragment(
		logger,
		classificationModalHref
	);

	return (
		<>
			{activeFacetModal === 'classification' ? (
				<CustomMarkupModal
					{...options}
					content={data}
					isLoading={isLoading}
					isError={isError}
				/>
			) : (
				<EvModal {...options} />
			)}
		</>
	);
};

Modals.propTypes = {
	activeFacetModal: PropTypes.string,
	options: PropTypes.shape({})
};

export default Modals;
